import React from "react";
export class Button extends React.Component {
  render() {
    var color = 'primary';
    if (this.props.color) color = this.props.color;
    var cls = 'ui-button ' + color + ' ink';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    } else {
      cls += ' smaller';
    }
    return /*#__PURE__*/React.createElement("button", {
      className: cls,
      onClick: this.props.onClick
    }, this.props.label);
  }
}
export class ButtonIcon extends React.Component {
  render() {
    var color = 'primary';
    if (this.props.color) color = this.props.color;
    var cls = 'ui-button ' + color + ' ink icon';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    } else {
      cls += ' smaller';
    }
    return /*#__PURE__*/React.createElement("button", {
      className: cls,
      onClick: this.props.onClick
    }, this.props.label, " ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, this.props.icon));
  }
}
export class CampaignButton extends React.Component {
  render() {
    var cls = 'ui-button primary ink';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    } else {
      cls += ' smaller';
    }
    if (this.props.color) {
      cls += ' ' + this.props.color;
    }
    return /*#__PURE__*/React.createElement("button", {
      className: cls,
      onClick: this.props.onClick
    }, this.props.label);
  }
}
export class ButtonClose extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "button-close-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons pointer",
      onClick: this.props.onClick
    }, "close"));
  }
}
export default {
  Button,
  CampaignButton,
  ButtonIcon,
  ButtonClose
};